import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(html: string | null | undefined): unknown {
    if (!html) {
      return html;
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
